import { OPEN_ROOM_POPUP, CLOSE_ROOM_POPUP } from '../constants/room-popup';

export const openRoomPopupAction = (payload) => ({
  type: OPEN_ROOM_POPUP,
  payload,
});

export const closeRoomPopupAction = () => ({
  type: CLOSE_ROOM_POPUP,
});
